import DownloadState from "./DownloadState";
import {DownloadActionType} from "./actions";
import {AnyAction} from "redux";

const initialState = new DownloadState();

const DownloadReducers = (state: DownloadState = initialState, action: AnyAction): DownloadState => {

    console.log(DownloadActionType[action.type] || 'INITIALIZING', action);

    const actionType: DownloadActionType = action.type;

    switch (actionType) {
        case DownloadActionType.SET_CURRENT_USER:
            return state.withUser(action.currentUser);
        case DownloadActionType.SET_DATACATALOG:
            return state.withDatacatalog(action.datacatalog);
        case DownloadActionType.SET_ROAD_OBJECT_TYPES:
            return state.withFeatureTypes(action.featureTypes)
        case DownloadActionType.SET_ROAD_OBJECTS:
            return state.withFeatures(action.features);
        case DownloadActionType.SET_DESTINATION:
            return state.withDestination(action.destination);
        case DownloadActionType.SET_USE_PROJECT_REF:
            return state.withUseProjectRef(action.useProjectRef);
        case DownloadActionType.SET_USE_CONTRACT_PROJECT_REF:
            return state.withUseContractProjectRef(action.useContractProjectRef);
        case DownloadActionType.SET_CONTRACT_PROJECT_REF:
            return state.withContractProjectRef(action.contractProjectRef);
        case DownloadActionType.SET_CUSTOM_PROJECT_REF:
            return state.withCustomProjectRef(action.customProjectRef);
        case DownloadActionType.SET_SOSI_FOR_NVDB_123:
            return state.withSosiForNvdb123(action.sosiForNvdb123);
        case DownloadActionType.SET_OPERATIONS:
            return state.withOperations(action.operations);
        case DownloadActionType.SET_SRID:
            return state.withSrid(action.srid)
        case DownloadActionType.SET_SELECTED_ROAD_OBJECT_TYPE_IDS:
            return state.withSelectedFeatureTypeIds(action.selectedFeatureTypeIds);
        case DownloadActionType.SET_LOADING:
            return state.withLoading(action.loading);
        case DownloadActionType.SET_LOADING_FEATURES:
            return state.withLoadingFeatures(action.loadingFeatures);
        case DownloadActionType.SET_LOADING_CONTRACT:
            return state.withLoadingContract(action.loadingContract);
        default:
            return state;
    }
};

export default DownloadReducers;
